export enum TypeCampaign {
  BLASTING = 'BLASTING',
  CHAT = 'CHAT',
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
  PREVIEW = 'PREVIEW',
}
